import type { DeviceProfile } from '@lumos/contracts';

/**
 * Когда показывать «Кто смотрит?» и куда уходить после выбора.
 *
 * Правило живёт отдельно от экрана, потому что оно про поведение, а не про
 * разметку: «спрашивать при каждом открытии» и «тот же зритель остаётся там,
 * где был» — то, что легко сломать незаметно, и то, что проверяется без
 * браузера.
 */

/**
 * Нужен ли экран выбора.
 *
 * Профиль один (или ни одного) — выбирать нечего, экран не появляется вовсе:
 * на приставке с единственным зрителем это был бы вопрос без вариантов между
 * «включил» и «смотрю».
 *
 * Профилей несколько — спрашиваем, если приложение открыли заново
 * (`askedInThisTab === false`) или если запомненный профиль к этому устройству
 * больше не привязан: его могли отвязать в админке, пока вкладка была закрыта.
 */
export function shouldAskProfile(input: {
  profiles: Pick<DeviceProfile, 'id'>[];
  chosenId: string | null;
  askedInThisTab: boolean;
}): boolean {
  if (input.profiles.length < 2) return false;
  const known = input.chosenId !== null && input.profiles.some((p) => p.id === input.chosenId);
  return !known || !input.askedInThisTab;
}

/**
 * Адрес после выбора.
 *
 * Тот же зритель — там же, где был: перезагруженная вкладка, открытая ссылка и
 * незакрытый плеер (`#/watch/...`) ведут туда, куда вели. Другой зритель — на
 * главную: чужая карточка и чужой плеер ему не принадлежат, а «продолжить» на
 * главной уже его собственное.
 *
 * `null` — адрес менять не нужно.
 */
export function hashAfterProfileChoice(previousId: string | null, chosenId: string): string | null {
  return previousId === chosenId ? null : '#/';
}
